import { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios'
import { getCookieAccessToken } from '../../../../auth/services/token-service'

export function basicBearerTokenRequestInterceptor(
  config: AxiosRequestConfig<any>
): InternalAxiosRequestConfig {
  const dataCookie = getCookieAccessToken()

  // Create a new headers object if it doesn't exist
  const headers = config.headers || {}

  // Merge the existing headers with the new Authorization header
  const updatedHeaders = {
    ...headers,
    Authorization: `Bearer ${dataCookie?.accessToken || ''}`
  }

  return {
    ...config,
    headers: updatedHeaders
  } as InternalAxiosRequestConfig
}
